import { Directive, HostListener, Input } from '@angular/core';
import { FileUploader } from './file-uploader';

@Directive({
    selector: '[dropFile]',
    standalone: true
})
export class DropFileDirective {

    @Input() host: FileUploader; // Referencia del componente host que esta usando la directiva

    constructor(
    ) {
    }

    @HostListener('drop', ['$event']) onDrop(e: DragEvent): void {
        e.preventDefault();
        e.stopPropagation();
        this.setDragOverCounter(0);
        const file = e.dataTransfer.files.item(0);
        this.host.uploadFile(file);
    }

    @HostListener('dragover', ['$event']) onDragOver(e: DragEvent): void {
        e.preventDefault();
        e.stopPropagation();
    }

    @HostListener('dragenter', ['$event']) onDragEnter(e: DragEvent): void {
        this.setDragOverCounter(this.host.dragOverCounter + 1);
    }

    @HostListener('dragleave', ['$event']) onDragLeave(e: DragEvent): void {
        this.setDragOverCounter(this.host.dragOverCounter - 1);
    }

    setDragOverCounter(value: number) {
        this.host.dragOverCounter = value;
        this.host.isDragOver = (this.host.dragOverCounter > 0);
    }
}
